<template>
	<section class="block-advantages-bottom advantages-bottom container_wide">
		<section
			class="advantages-bottom__advantage"
			v-for="(advantage, i) in advantages"
			:key="`advantage-${i}`"
		>
			<div
				class="advantages-bottom__icon-wrapper"
				:class="{ 'advantages-bottom__icon-wrapper_second': i === 1 }"
			>
				<template v-if="i === 1">
					<img :src="advantage.icon" alt="" />
					<img :src="advantage.icon" alt="" />
				</template>
				<template v-else>
					<img :src="advantage.icon" alt="" />
				</template>
			</div>
			<img class="advantages-bottom__image" :class="`advantages-bottom__image_${i+1}`" />
			<h4 class="advantages-bottom__text" v-html="advantage.title"></h4>
			<button
				class="advantages-bottom__button button button_primary"
				@click="getCall({ type: 'sale', text: 'Получить выгоду' })"
			>
				Получить выгоду
			</button>
		</section>
	</section>
</template>

<script>
import Mixin from '../common/mixin';
import filters from '../common/finance';

// icons
import creditIcon from "../images/icons/credit.svg";
import carIcon from "../images/icons/car.svg";
import shieldIcon from "../images/icons/shield.svg";

// images
import image1 from '../images/advantages/1.jpg';
import image2 from '../images/advantages/2.jpg';
import image3 from '../images/advantages/3.jpg';
import image4 from '../images/advantages/4.jpg';

export default {
	name: "block-advantages-bottom",
	mixins: [Mixin, filters],
	data() {
		return {
			advantages: [
				{
					title: "Рассчитать кредит",
					icon: creditIcon,
					image: image1,
				},
				{
					title: "Трейд-Ин с дополнительной выгодой",
					icon: carIcon,
					image: image2,
				},
				{
					title: "Спецпредложение",
					icon: carIcon,
					image: image3,
				},
				{
					title: "ГАРАНТИЙНАЯ ПОДДЕРЖКА 5 лет",
					icon: shieldIcon,
					image: image4,
				},
			],
		}
	},
}
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.advantages-bottom {
	display: grid;
	grid-template-columns: repeat(2, minmax(320px, 1fr));
	grid-auto-rows: auto;
	column-gap: 10px;
	row-gap: 70px;
	width: 100%;
	margin-top: 100px;
	margin-bottom: 100px;
	padding: 0 20px;

	&__advantage {
		position: relative;
	}

	&__image {
		width: 720px;
		height: 300px;
		margin-bottom: 15px;

		@each $i in 1, 2, 3, 4 {
			&_#{$i} {
				background: url('../images/advantages/#{$i}.jpg') no-repeat;
        background-size: cover;
        background-position: center;
      }
		}
	}

	&__text {
		font-size: 18px;
		line-height: 1;
		margin-bottom: 20px;
		text-transform: uppercase;
	}

	&__button {
		max-width: 360px;
	}

	&__icon-wrapper {
		position: absolute;
		top: 20px;
		left: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 75px;
		height: 75px;
		border-radius: 50%;
		background-color: #fff;

		&_second {
			flex-direction: column;

			img:last-child {
				margin-top: -5px;
				transform: scale(0.8);
			}
		}
	}
}

@media (max-width: 1509px) {
	.advantages-bottom {
		&__image {
			width: calc(100vw / 2 - 25px);
		}
	}
}

@media (max-width: 760px) {
	.advantages-bottom {
		grid-template-columns: auto;

		&__image {
			width: 100%;
			background-position: 20%;
		}
	}
}


@media (max-width: 640px) {
	.advantages-bottom {
		&__button {
			max-width: 100%;
		}
	}
}

@media (max-width: 400px) {
	.advantages-bottom {
		&__text {
			text-align: center;
		}
	}
}
</style>
